import React        from 'react'
import axios        from 'axios'
import config       from './config'
import DeploymentTable  from './DeploymentTable'

export default class DetectionSetting extends React.Component {
  constructor() {
    super()
    this.state = {
      detectionSettings: [],
      deploymentData: {},
      deploymentMeta: {},
      checkedShowNotEmpty: false,
      checkedShowRedServer: false,
      alerts: []
    }
    axios.defaults.withCredentials = true
  }

  componentWillMount() {
    var localDetectionSettings = []
    var localDeploymentData = {}
    var localAlerts = []
    var localDeploymentCompany = {}

    this.getDeployments().then(response => {
      response.data.deployment.forEach(deployment => {
        if(deployment.status !== 0 || deployment.deploymentServer.length > 0) {
          const id = deployment.detectionSettingId.split('_')[1]
          localDetectionSettings.push(id)
          localDeploymentData[id] = deployment
          var companies = deployment.detectionSetting.developerSubscription.map(ds => {
            return {
              id: ds.developer.company.id.split('_')[1],
              name: ds.developer.company.name
            }
          })
          // Distinct
          localDeploymentCompany[id] = Array.from(new Set(companies.map(c => c.id))).map(id => {
            return {
              id: id,
              name: companies.find(s => s.id === id).name
            }
          })
          if (deployment.status === 0 && deployment.deploymentServer.length > 0) {
            var alertObj = {
              type: 'warning',
              message: `Deployment ${deployment.id} (${deployment.detectionSetting.id}-${deployment.detectionSetting.service}) is inactive but has some servers in it.`
            }
            localAlerts.push(alertObj)
          } else if(deployment.status === 1 && deployment.deploymentServer.length === 0 && deployment.onDemand !== 1) {
            var alertOb = {
              type: 'error',
              message: `Deployment ${deployment.id} (${deployment.detectionSetting.id}-${deployment.detectionSetting.service}) is active but has no servers in it.`
            }
            localAlerts.push(alertOb)
          }
        }
      })
      this.setState({
        detectionSettings: localDetectionSettings,
        deploymentData: localDeploymentData,
        deploymentCompany: localDeploymentCompany,
        alerts: localAlerts
      })
    })
  }

  getDeployments() {
    return axios.get(config.GRAPH.ENDPOINT + 'deployment?fields=id,detectionSettingId,detectionSetting(developerSubscription(developer(company))),layer,synchronous,video,onDemand,meta,status,DetectionSetting,DeploymentServer(id,meta,dateUpdated,Server)&version=2').catch(error => console.log())
  }

  showNotEmpty() {     
    this.setState({
      checkedShowNotEmpty: !this.state.checkedShowNotEmpty
    })
  }

  showRedServer() {
    this.setState({
      checkedShowRedServer: !this.state.checkedShowRedServer
    })
  }

  render() {
    const {detectionSettings, deploymentData, checkedShowNotEmpty, alerts, checkedShowRedServer, deploymentCompany} = this.state
    return(
      <div>
        {alerts.map((item, index) => (
          <div className="externalAlert" key={'external' + index}><div className={'alert ' + item.type} key={index}>{item.message}</div></div>
        ))}
        <br/><br/>
        <label>
          Show only detection settings not empty: 
          <input
          name="showNotEmpty"
          type="checkbox"
          onChange={() => this.showNotEmpty()} />

          <br/>

          Show only red servers: 
          <input
          name="showRedServer"
          type="checkbox"
          onChange={() => this.showRedServer()} />
        </label>
        {detectionSettings.map((item, index) => (
          // Small hack to check if the obj is empty.
          <div key={item} className = {checkedShowNotEmpty && !(deploymentData[item].deploymentServer.length) ? 'emptyDetection' : ''}>
            {/* The next part was done because setState is asyncronus so I get back a nullpointer exception because it hasn't finish yet. Fixed with this ack. */}
            <DeploymentTable data={deploymentData[item].deploymentServer ? deploymentData[item].deploymentServer : ["Working"]}
            checkedShowRedServer={checkedShowRedServer}
            detSetId={item}
            detSetService={deploymentData[item].detectionSetting.service}
            status={deploymentData[item].status}
            deploymentCompany={deploymentCompany[item]}/>
          </div>
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Deployments.js